(function () {
  'use strict';

  const TAG = 'uwe-header-nav';
  if (!window.customElements || customElements.get(TAG)) return;

  const COMPONENT_CSS = `
/* ==========================================================================
   UWE Header Nav (component)
   ========================================================================== */
uwe-header-nav{
  display: flex;
  min-width: 0;
  width: 100%;
  height: 100%;
  align-items: flex-end;
}

/* Inline row */
uwe-header-nav [data-uwe-inline]{
  display: flex;
  align-items: flex-end;
  gap: var(--uwe-gap, 10px);
  min-width: 0;
  width: 100%;
  justify-content: space-around;
}

uwe-header-nav [data-uwe-inline] > .site-header__navItem{
  flex: 1 1 0;
  min-width: var(--uwe-min-item, 100px) !important;
  height: 32px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;

  border-radius: 8px;

  background: color-mix(in srgb, var(--text) 75%, transparent);
  border: 1px solid rgba(255,255,255,0.18);

  color: white;
  text-decoration: none;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  transform: translateY(0);
  transition: transform .12s ease, color .12s ease, background .12s ease, border-color .12s ease;
}

uwe-header-nav [data-uwe-inline] > .site-header__navItem:hover{
  background: var(--accent);
  text-decoration: none;
  transform: translateY(-1px);
}

uwe-header-nav [data-uwe-inline] > .site-header__navItem.is-active:not([data-lucky-menu="true"]){
  cursor: default;
}

uwe-header-nav [data-uwe-inline] > .site-header__navItem:focus-visible{
  box-shadow: var(--focus);
}

uwe-header-nav [data-uwe-inline] > .site-header__navItem.is-active{
  background: var(--accent);
  color: #111;
  border-color: color-mix(in srgb, var(--accent) 65%, rgba(255,255,255,0.18));
}

uwe-header-nav .site-header__navIcon{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  flex: 0 0 auto;
}

uwe-header-nav .site-header__navIcon svg{
  display: block;
  width: 100%;
  height: 100%;
}

uwe-header-nav .site-header__navLabel{
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

uwe-header-nav[data-mode="compact"] [data-uwe-inline]{
  position: absolute;
  left: -9999px;
  top: 0;
  visibility: hidden;
  pointer-events: none;
}

/* Keep the cart count visually aligned with the existing header action style. */
.site-header__action--cart{
  position: relative;
}

.site-header__cartCount{
  position: absolute;
  right: -5px;
  top: -6px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  min-width: 18px;
  height: 18px;
  padding: 0 5px;

  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--accent) 65%, rgba(255,255,255,.3));
  background: var(--accent);
  color: #111;

  font-size: 10px;
  font-weight: 1000;
  line-height: 1;
  box-shadow: var(--shadow-sm);
}

.site-header__cartCount.is-empty{
  display: none;
}

/* Mobile: keep the same tile look, but icon-only and no burger needed. */
@media (max-width: 899px){
  uwe-header-nav{
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    width: 100%;
  }

  .site-header.site-header--compact .site-header__nav{
    display: flex;
  }

  uwe-header-nav[data-mode="compact"] [data-uwe-inline]{
    position: static;
    left: auto;
    top: auto;
    visibility: visible;
    pointer-events: auto;
  }

  uwe-header-nav [data-uwe-inline]{
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    gap: var(--uwe-gap, 10px);
    width: auto;
  }

  uwe-header-nav [data-uwe-inline] > .site-header__navItem{
    flex: 0 0 auto;
    min-width: 32px !important;
    width: 32px;
    height: 32px;
    padding: 0;

    border-radius: 8px;
  }

  uwe-header-nav .site-header__navLabel{
    display: none;
  }

  uwe-header-nav .site-header__navIcon{
    width: 15px;
    height: 15px;
  }

  uwe-header-nav [data-uwe-inline] > .site-header__navItem.is-active::after{
    display: none;
  }

  .site-header__cartCount{
    right: -5px;
    top: -5px;
    min-width: 17px;
    height: 17px;
    font-size: 10px;
  }
}

@media (max-width: 380px){
  uwe-header-nav [data-uwe-inline]{
    gap: 6px;
  }

  uwe-header-nav [data-uwe-inline] > .site-header__navItem{
    min-width: 30px !important;
    width: 30px;
    height: 30px;
  }

  uwe-header-nav .site-header__navIcon{
    width: 14px;
    height: 14px;
  }
}
`;

  const ICONS = {
    search: `
      <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.7 18.4a7.7 7.7 0 1 1 0-15.4 7.7 7.7 0 0 1 0 15.4Z" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M16.4 16.4 21 21" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
    collections: `
      <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.5 5.5h6v6h-6v-6Z" stroke="currentColor" stroke-width="2.1" stroke-linejoin="round"/>
        <path d="M13.5 5.5h6v6h-6v-6Z" stroke="currentColor" stroke-width="2.1" stroke-linejoin="round"/>
        <path d="M4.5 14.5h6v6h-6v-6Z" stroke="currentColor" stroke-width="2.1" stroke-linejoin="round"/>
        <path d="M13.5 14.5h6v6h-6v-6Z" stroke="currentColor" stroke-width="2.1" stroke-linejoin="round"/>
      </svg>
    `,
    dice: `
      <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="4" width="16" height="16" rx="4" stroke="currentColor" stroke-width="2.1"/>
        <circle cx="8.5" cy="8.5" r="1.35" fill="currentColor"/>
        <circle cx="15.5" cy="8.5" r="1.35" fill="currentColor"/>
        <circle cx="12" cy="12" r="1.35" fill="currentColor"/>
        <circle cx="8.5" cy="15.5" r="1.35" fill="currentColor"/>
        <circle cx="15.5" cy="15.5" r="1.35" fill="currentColor"/>
      </svg>
    `
  };

  const injectCssOnce = (() => {
    let done = false;
    return () => {
      if (done) return;
      done = true;

      const style = document.createElement('style');
      style.setAttribute('data-uwe-header-nav', 'true');
      style.textContent = COMPONENT_CSS;
      document.head.appendChild(style);
    };
  })();

  const isObject = (v) => v && typeof v === 'object' && !Array.isArray(v);

  class UweHeaderNav extends HTMLElement {
    constructor() {
      super();

      this._cfg = null;
      this._mode = 'full';
      this._open = false;

      this._scope = null;
      this._compactClass = null;

      this._inlineEl = null;
      this._toggleEls = [];

      this._resizeObs = null;

      this._boundRecalc = this._recalcMode.bind(this);
      this._boundToggleClick = this._onToggleClick.bind(this);
      this._boundInlineClick = this._onInlineClick.bind(this);
      this._boundCartUpdated = this._onCartUpdated.bind(this);
    }

    connectedCallback() {
      injectCssOnce();

      this._cfg = this._readConfig();
      if (!this._cfg) return;

      this._scope = this._resolveScope(this._cfg.modeClassTarget);
      this._compactClass = this._cfg.compactClass || 'site-header--compact';

      this._ensureInlineContainer();
      this._renderInlineMenus();

      this._bindToggles();
      this._setupResizeObserver();

      this.addEventListener('click', this._boundInlineClick);
      document.addEventListener('cart:updated', this._boundCartUpdated);

      requestAnimationFrame(this._boundRecalc);
      window.addEventListener('resize', this._boundRecalc, { passive: true });

      this._refreshCartCount();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._boundRecalc);
      this.removeEventListener('click', this._boundInlineClick);
      document.removeEventListener('cart:updated', this._boundCartUpdated);

      if (this._resizeObs) {
        this._resizeObs.disconnect();
        this._resizeObs = null;
      }

      this._unbindToggles();
    }

    _readConfig() {
      const script = this.querySelector('script[type="application/json"][data-config]');
      if (!script) return null;

      try {
        const parsed = JSON.parse(script.textContent || '{}');
        if (!isObject(parsed)) return null;

        parsed.fitMode = parsed.fitMode || 'measure';
        parsed.minItemWidth = Number(parsed.minItemWidth || 0) || 0;
        parsed.gap = Number(parsed.gap || 0) || 0;

        parsed.toggleSelector = parsed.toggleSelector || null;
        parsed.modeClassTarget = parsed.modeClassTarget || '.site-header';
        parsed.compactClass = parsed.compactClass || 'site-header--compact';

        parsed.menus = Array.isArray(parsed.menus) ? parsed.menus : [];

        return parsed;
      } catch (e) {
        return null;
      }
    }

    _resolveScope(modeClassTarget) {
      if (typeof modeClassTarget === 'string' && modeClassTarget.length > 0) {
        const closest = this.closest(modeClassTarget);
        if (closest) return closest;

        const header = this.closest('.site-header') || this.closest('header');
        if (header) {
          const found = header.querySelector(modeClassTarget);
          if (found) return found;
          return header;
        }

        const global = document.querySelector(modeClassTarget);
        if (global) return global;
      }

      return this.closest('.site-header') || this.closest('header') || document.documentElement;
    }

    _ensureInlineContainer() {
      let el = this.querySelector('[data-uwe-inline]');
      if (!el) {
        el = document.createElement('div');
        el.setAttribute('data-uwe-inline', '1');
        this.appendChild(el);
      }
      this._inlineEl = el;

      if (this._cfg && Number.isFinite(this._cfg.gap)) {
        this._inlineEl.style.gap = `${this._cfg.gap}px`;
      }
    }

    _isLuckyActiveFromUrl() {
      try {
        return new URLSearchParams(window.location.search).get('lucky') === '1';
      } catch (error) {
        return false;
      }
    }

    _renderInlineMenus() {
      const menus = Array.isArray(this._cfg.menus) ? this._cfg.menus : [];
      this._inlineEl.innerHTML = '';

      const frag = document.createDocumentFragment();
      const luckyActiveFromUrl = this._isLuckyActiveFromUrl();

      for (let i = 0; i < menus.length; i++) {
        const m = menus[i] || {};
        const label = (typeof m.label === 'string' && m.label.trim()) ? m.label.trim() : `Menu ${i + 1}`;
        const url = (typeof m.url === 'string' && m.url.trim()) ? m.url.trim() : '#';
        const icon = (typeof m.icon === 'string' && m.icon.trim()) ? m.icon.trim() : '';
        const isLucky = m.lucky === true;
        const isActive = m.active === true || (isLucky && luckyActiveFromUrl);

        const a = document.createElement('a');
        a.className = 'site-header__navItem';
        a.href = url;
        a.setAttribute('data-menu-index', String(i));
        a.setAttribute('aria-label', label);

        if (isLucky) {
          a.setAttribute('data-lucky-menu', 'true');
        }

        if (isActive) {
          a.classList.add('is-active');
          a.setAttribute('aria-current', 'page');
        }

        if (ICONS[icon]) {
          const iconSpan = document.createElement('span');
          iconSpan.className = 'site-header__navIcon';
          iconSpan.setAttribute('aria-hidden', 'true');
          iconSpan.innerHTML = ICONS[icon];
          a.appendChild(iconSpan);
        }

        const labelSpan = document.createElement('span');
        labelSpan.className = 'site-header__navLabel';
        labelSpan.textContent = label;
        a.appendChild(labelSpan);

        const minW = Number(this._cfg.minItemWidth || 0);
        if (minW > 0) a.style.minWidth = `${minW}px`;

        frag.appendChild(a);
      }

      this._inlineEl.appendChild(frag);
    }

    _setupResizeObserver() {
      if (!('ResizeObserver' in window)) return;

      this._resizeObs = new ResizeObserver(() => this._recalcMode());

      const nav = this.closest('.site-header__nav') || this.parentElement || this;
      this._resizeObs.observe(nav);
    }

    _recalcMode() {
      if (!this._cfg || this._cfg.fitMode !== 'measure') return;

      const nav = this.closest('.site-header__nav') || this.parentElement || this;
      if (!nav) return;

      const available = Math.floor(nav.getBoundingClientRect().width);

      const menus = Array.isArray(this._cfg.menus) ? this._cfg.menus : [];
      const count = menus.length;

      const minW = Number(this._cfg.minItemWidth || 0) || 0;
      const gap = Number(this._cfg.gap || 0) || 0;

      let required = (count * minW) + (Math.max(0, count - 1) * gap);
      required += 24;

      this.style.setProperty('--uwe-min-item', `${minW}px`);
      this.style.setProperty('--uwe-gap', `${gap}px`);

      const nextMode = (required > available) ? 'compact' : 'full';
      if (nextMode !== this._mode) this._setMode(nextMode);
    }

    _setMode(mode) {
      this._mode = (mode === 'compact') ? 'compact' : 'full';

      this.setAttribute('data-mode', this._mode);

      if (this._scope && this._compactClass) {
        if (this._mode === 'compact') this._scope.classList.add(this._compactClass);
        else this._scope.classList.remove(this._compactClass);
      }

      if (this._mode !== 'compact') this._setOpen(false);
    }

    _onInlineClick(e) {
      const clickedNavItem = e.target.closest('.site-header__navItem');
      if (!clickedNavItem) return;

      const luckyLink = e.target.closest('[data-lucky-menu="true"]');

      /*
        Lucky should always work, even when it is currently marked active.
        It picks a new random product and appends ?lucky=1.
      */
      if (luckyLink) {
        const index = Number(luckyLink.getAttribute('data-menu-index'));
        const menu = Array.isArray(this._cfg.menus) ? this._cfg.menus[index] : null;
        const urls = menu && Array.isArray(menu.luckyProducts) ? menu.luckyProducts.filter(Boolean) : [];

        if (!urls.length) return;

        const randomIndex = Math.floor(Math.random() * urls.length);
        const randomUrl = urls[randomIndex];

        if (!randomUrl) return;

        e.preventDefault();

        const url = new URL(randomUrl, window.location.origin);
        url.searchParams.set('lucky', '1');
        window.location.href = url.toString();

        return;
      }

      /*
        If Search or Collections is already active, clicking it should not
        navigate/reload/redirect. This prevents Collections from sending users
        back to All Comics while they are already on a collection page.
      */
      if (clickedNavItem.classList.contains('is-active')) {
        e.preventDefault();
      }
    }

    _bindToggles() {
      const sel = this._cfg && this._cfg.toggleSelector;
      if (!sel || typeof sel !== 'string') return;

      const header = this.closest('.site-header') || this.closest('header') || document;
      const toggles = Array.from(header.querySelectorAll(sel));

      this._toggleEls = toggles;
      toggles.forEach((el) => el.addEventListener('click', this._boundToggleClick));
    }

    _unbindToggles() {
      if (!this._toggleEls || this._toggleEls.length === 0) return;
      this._toggleEls.forEach((el) => el.removeEventListener('click', this._boundToggleClick));
      this._toggleEls = [];
    }

    _onToggleClick(e) {
      e.preventDefault();
      if (this._mode !== 'compact') return;
      this._setOpen(!this._open);
    }

    _setOpen(open) {
      const next = open === true;
      if (next === this._open) return;

      this._open = next;

      if (this._toggleEls && this._toggleEls.length > 0) {
        this._toggleEls.forEach((el) => {
          el.setAttribute('aria-expanded', this._open ? 'true' : 'false');
        });
      }

      this.setAttribute('data-open', this._open ? 'true' : 'false');
    }

    _onCartUpdated(event) {
      if (event && event.detail && event.detail.cart) {
        this._updateCartCount(event.detail.cart.item_count);
        return;
      }

      this._refreshCartCount();
    }

    async _refreshCartCount() {
      try {
        const response = await fetch('/cart.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });

        if (!response.ok) return;

        const cart = await response.json();
        this._updateCartCount(cart.item_count);
      } catch (error) {
        // Keep server-rendered count if cart fetch fails.
      }
    }

    _updateCartCount(count) {
      const header = this.closest('.site-header') || document;
      const badges = header.querySelectorAll('[data-header-cart-count]');
      const value = Math.max(0, Number(count || 0));

      badges.forEach((badge) => {
        badge.textContent = String(value);
        badge.setAttribute('aria-label', value + ' items in cart');
        badge.classList.toggle('is-empty', value === 0);
      });
    }
  }

  customElements.define(TAG, UweHeaderNav);
})();